module.exports = __webpack_public_path__ + "static/media/bgMusic.23f5dae.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/music/bgMusic.mp3
// module id = +YfH
// module chunks = 34